/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useClasses = makeStyles((theme) => ({
    header: {
        marginBottom: theme.spacing(8),
    },
    viacal: {
        lineHeight: `${theme.spacing(5.5)}px !important`,
    },
    fields: {
        display: "flex",
        justifyContent: "space-between",
        margin: theme.spacing(1, 0, 2),
        "& > div": {
            "& > .MuiInputBase-root": {
                backgroundColor: "inherit",
            },
        },
    },
    errorMessage: {
        marginTop: `${theme.spacing(2)}px !important`,
        marginBottom: `${theme.spacing(2)}px !important`,
    },
}));
